import { request } from '../request'

export function login (data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

// 获取底部院校信息
export function getInfoItemList () {
  return request({
    url: '/app/infoItem',
    method: 'get'
  })
}

// 获取首页栏目列表
export function getCatalog (data) {
  data = data || { root: true }
  return request({
    url: '/app/category',
    method: 'get',
    data
  })
}

// 获取通知列表
export function getMsgList (data) {
  return request({
    url: '/app/notice',
    method: 'get',
    data
  })
}

// 获取通知信息详情
export function getNoticeInfo (data) {
  return request({
    url: '/app/notice/' + data.id,
    method: 'get'
  })
}

// 获取轮播图图片
export function getImgList (data) {
  return request({
    url: '/app/getImageNotice',
    method: 'get',
    data
  })
}

// 获取各栏目左侧子节点列表
// export function getNavList (data) {
//   return request({
//     url: '/app/category',
//     method: 'get',
//     data
//   })
// }

// 获取服务中心标题及介绍
export function getServiceInfo (data) {
  return request({
    url: '/app/textSafeguard',
    method: 'get',
    data
  })
}

// 获取职责分工列表
export function getDeptDutyList (data) {
  return request({
    url: '/app/deptDuty',
    method: 'get',
    data
  })
}

// 服务中心
export function getMinisterCenter (data) {
  return request({
    url: '/app/ministerCenter',
    method: 'get',
    data
  })
}

// 获取网页标题
export function getTitleName () {
  return request({
    url: '/app/getWebTitle',
    method: 'get'
  })
}

// 获取底部院校信息
export function getSystemConfig () {
  return request({
    url: '/app/systemConfig',
    method: 'get'
  })
}
